import React from "react";

const HeaderRow = () => {
  return (
    <div className="row">
      <div className="imgCont">Author</div>
      <div className="creation_date">CreationDate</div>
      <div className="title">Title</div>
      <div className="ques_id">Question ID</div>
    </div>
  );
};
export default HeaderRow;
